var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"srcset":_vm.webpSrc,"type":"image/webp"}}),_c('source',{attrs:{"srcset":_vm.jpegSrc,"type":"image/jpeg"}}),_c('img',{staticClass:"image-thumbnail",attrs:{"src":_vm.jpegSrc,"alt":""},on:{"error":function($event){return _vm.$emit('error', $event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }